import { createSelector, createSlice } from '@reduxjs/toolkit'
import { apiCallBegan } from '../actions/api'

const initialState = {
    list: { data: [], totalCount: 0 },
    lookups: [],
    loading: false,
    error: null,
    refreshing: false,
}

const medcondSlice = createSlice({
    name: 'medcond',
    initialState,
    reducers: {
        refreshRequested: (state) => {
            state.loading = true
            state.refreshing = true
            state.error = null
        },
        apiRequested: (state) => {
            state.loading = true
            state.error = null
        },
        apiRequestedFailed: (state, action) => {
            state.error = action.payload
            state.loading = false
            state.refreshing = false
        },
        getMedicalConditionTypes: (state, action) => {
            state.list = action.payload
            state.loading = false
            state.refreshing = false
        },
        getMedicalConditionTypeLookup: (state, action) => {
            const p = action.payload
            state.lookups = Array.isArray(p) ? p : p?.data ?? []
            state.loading = false
        },
        getExistingMedicalConditionTypeLookupById: (state, action) => {
            const index = state.lookups.findIndex((x) => x.id === action.payload.id)
            if (index >= 0) state.lookups[index] = action.payload
            else state.lookups.push(action.payload)
            state.loading = false
        },
        getExistingMedicalConditionTypeById: (state, action) => {
            const index = state.list.data.findIndex((x) => x.id === action.payload.id)
            if (index >= 0) state.list.data[index] = action.payload
            else {
                state.list.data.push(action.payload)
                state.list.totalCount++
            }
            state.loading = false
        },
        addNewMedicalConditionType: (state, action) => {
            state.list.data.push(action.payload)
            state.list.totalCount++
            state.loading = false
        },
        updateExistingMedicalConditionType: (state, action) => {
            const index = state.list.data.findIndex((x) => x.id === action.payload.id)
            if (index >= 0) state.list.data[index] = action.payload
            state.loading = false
        },
        removeMedicalConditionType: (state, action) => {
            const index = state.list.data.findIndex((x) => x.id === action.payload.id)
            if (index >= 0) {
                state.list.data.splice(index, 1)
                state.list.totalCount--
            }
            state.loading = false
        },
    },
})

const selectItems = (state) => state.data
const selectItemId = (state, itemId) => itemId
const selectItemById = createSelector([selectItems, selectItemId], (items, itemId) => {
    if (items) {
        const index = items.findIndex((item) => item.id === itemId)
        if (index >= 0) return { ...items[index] }
    }
    return {}
})
export { selectItemById }

export const {
    refreshRequested,
    apiRequested,
    apiRequestedFailed,
    getMedicalConditionTypes,
    getMedicalConditionTypeLookup,
    getExistingMedicalConditionTypeLookupById,
    getExistingMedicalConditionTypeById,
    addNewMedicalConditionType,
    updateExistingMedicalConditionType,
    removeMedicalConditionType,
} = medcondSlice.actions
export default medcondSlice.reducer

export const getMedicalConditionTypeList = (filter, refresh = false) => {
    return apiCallBegan({
        url: `/api/Setting/medicalConditionType/list`,
        method: 'post',
        data: filter,
        onStart: refresh ? refreshRequested.type : apiRequested.type,
        onSuccess: getMedicalConditionTypes.type,
        onError: apiRequestedFailed.type,
    })
}

export const getMedicalConditionTypeLookupList = (filter) => {
    const url = filter?.name
        ? `/api/Setting/medicalConditionType/lookup/list?search=${filter.name}`
        : `/api/Setting/medicalConditionType/lookup/list`
    return apiCallBegan({
        url,
        method: 'get',
        data: filter,
        onStart: apiRequested.type,
        onSuccess: getMedicalConditionTypeLookup.type,
        onError: apiRequestedFailed.type,
    })
}

export const getMedicalConditionTypeLookupById = (filter) => {
    return apiCallBegan({
        url: `/api/Setting/medicalConditionType/lookup/${filter.id}`,
        method: 'get',
        data: filter,
        onStart: apiRequested.type,
        onSuccess: getExistingMedicalConditionTypeLookupById.type,
        onError: apiRequestedFailed.type,
    })
}

export const getMedicalConditionTypeById = (filter) => {
    return apiCallBegan({
        url: `/api/Setting/medicalConditionType/${filter.id}`,
        method: 'get',
        data: filter,
        onStart: apiRequested.type,
        onSuccess: getExistingMedicalConditionTypeById.type,
        onError: apiRequestedFailed.type,
    })
}

export const addMedicalConditionType = (payload) => {
    return apiCallBegan({
        url: `/api/Setting/medicalConditionType/add`,
        method: 'post',
        data: payload,
        onStart: apiRequested.type,
        onSuccess: addNewMedicalConditionType.type,
        onError: apiRequestedFailed.type,
    })
}

export const updateMedicalConditionType = (payload) => {
    return apiCallBegan({
        url: `/api/Setting/medicalConditionType/update`,
        method: 'PUT',
        data: payload,
        onStart: apiRequested.type,
        onSuccess: updateExistingMedicalConditionType.type,
        onError: apiRequestedFailed.type,
    })
}

export const deleteMedicalConditionType = (payload) => {
    return apiCallBegan({
        url: '/api/Setting/medicalConditionType/delete',
        method: 'DELETE',
        data: payload,
        onStart: apiRequested.type,
        onSuccess: removeMedicalConditionType.type,
        onError: apiRequestedFailed.type,
    })
}
